function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.854 5.076V3.144h-9.8v1.932h9.8zm-3.91 7.868v-1.978H7.056v1.978h5.888zm3.91-3.91V7.056h-9.8v1.978h9.8zM17.868.2c.522 0 .974.192 1.358.576.382.384.574.836.574 1.358v11.778c0 .522-.192.982-.576 1.38-.384.398-.836.598-1.358.598H6.09c-.522 0-.982-.2-1.38-.598-.398-.398-.598-.858-.598-1.38V2.134c0-.522.2-.974.598-1.358S5.568.2 6.09.2h11.778zM2.132 4.11v13.756h13.756V19.8H2.132c-.522 0-.974-.192-1.358-.576S.2 18.388.2 17.868V4.11h1.932z"
})));